import { render, staticRenderFns } from "./bf-input.vue?vue&type=template&id=085d312e&scoped=true&lang=pug&"
import script from "./bf-input.vue?vue&type=script&lang=js&"
export * from "./bf-input.vue?vue&type=script&lang=js&"
import style0 from "./bf-input.vue?vue&type=style&index=0&id=085d312e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085d312e",
  null
  
)

export default component.exports